import { resize } from './components/header/resize.js';

resize();
